<template>
  <div style="padding: 5px 10px; font-size: 12px">
    <vs-popup title="Total Alerts" :active.sync="alertOpenLocal">
      <vs-table :data="finalData.alerts">
        <template slot="thead">
          <vs-th>{{ $t('ALERT') }}</vs-th>
          <vs-th>{{ $t('DRIVER NAME') }}</vs-th>
          <vs-th>{{ $t('DRIVER PHONE') }}</vs-th>
          <vs-th>{{ $t('SPEED') }}</vs-th>
          <vs-th>{{ $t('DURATION') }}</vs-th>
          <vs-th>{{ $t('DATE') }}</vs-th>
          <vs-th>{{ $t('LOCATION') }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody id="isi_table">
            <vs-tr
              class="cursor-default"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in finalData.alerts">
              <vs-td :data="finalData.alerts[indextr].event_type">
                <p class="product-name font-medium">
                  {{
                    tr.event_type.includes('POI') ||
                    tr.event_type.includes('GEO')
                      ? tr.event
                      : $t(tr.event_name)
                  }}
                </p>
              </vs-td>
              <vs-td :data="finalData.alerts[indextr].driver_name">
                <p class="product-name font-medium">
                  {{ tr.driver_name ? tr.driver_name : '-' }}
                </p>
              </vs-td>
              <vs-td :data="finalData.alerts[indextr].driver_phone">
                <p class="product-name font-medium">
                  {{ tr.driver_phone ? tr.driver_phone : '-' }}
                </p>
              </vs-td>
              <vs-td :data="finalData.alerts[indextr].speed">
                <p class="product-name font-medium">{{ tr.speed }} Km/h</p>
              </vs-td>
              <vs-td :data="finalData.alerts[indextr].duration">
                <p class="product-name font-medium">
                  {{ getSimpleDurationV2(tr.duration) }}
                </p>
              </vs-td>
              <vs-td class="py-2" :data="finalData.alerts[indextr].device_time">
                <p>{{ formatDate(tr.device_time) }} WIB</p>
              </vs-td>
              <vs-td class="py-2" :data="finalData.alerts[indextr].location">
                <!-- <p
                    style="min-width: 250px; max-width: 450px"
                    v-if="tr.address">
                    {{ tr.address }}
                  </p>
                  <p v-else class="loader_1"></p> -->

                <div class="flex flex-row" style="gap: 10px">
                  <a target="_blank" :href="tr.gmaps_url">{{
                    $t('Show Google Maps')
                  }}</a>
                  <p style="width: fit-content">|</p>
                  <a target="_blank" :href="tr.streetview_url">{{
                    $t('Show Street View')
                  }}</a>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-popup>
    <div class="item flex flex-row" style="gap: 5px">
      <div class="flex flex-col items-center mt-1" style="gap: 5px">
        <img
          :src="isGeo ? icons.geoDot : icons.poiDot"
          width="20px"
          alt="dot" />
        <div
          v-if="!isGeoEnd"
          style="
            height: 100%;
            width: fit-content;
            border-left: 0.3px solid #e0e0e0;
          "></div>
      </div>
      <div class="flex flex-col" style="width: 100%">
        <vs-card class="mb-1" :data="finalData.alerts">
          <template>
            <div class="p-2">
              <div class="flex flex-row" style="justify-content: space-between">
                <h5 v-if="!isGeo">{{ finalData.poi_name }}</h5>
                <h5 v-else>{{ finalData.geofence_name }}</h5>
                <!-- <p v-if="isGeo">{{ finalData.device_time }}</p> -->
                <!-- <p v-else>{{ finalData.time_in }}</p> -->
              </div>
              <div
                class="my-1"
                style="
                  width: 100%;
                  height: fit-content;
                  border-bottom: 0.3px solid #e0e0e0;
                "></div>
              <a
                :href="`https://www.google.com/maps/search/?api=1&query=${finalData.latitude},${finalData.longitude}`"
                target="_blank">
                <p>
                  {{
                    finalData.address ? finalData.address : 'Loading Address...'
                  }}
                </p>
              </a>
              <table class="mt-3">
                <tbody>
                  <tr>
                    <td class="text-sm">Average Chiller Temperature</td>
                    <td class="text-sm">:</td>
                    <td class="text-sm">
                      {{
                        finalData.dallas_temperature_1
                          ? finalData.dallas_temperature_1
                          : '0'
                      }}
                      <sup style="color: black">o</sup>C
                    </td>
                  </tr>
                  <tr v-if="userRole.role_name != 'Customer'">
                    <td class="text-sm">Odometer</td>
                    <td class="text-sm">:</td>
                    <td class="text-sm">
                      {{ finalData.odometer ? finalData.odometer / 1000 : '0' }}
                      km
                    </td>
                  </tr>
                  <tr v-if="!isGeo">
                    <td class="text-sm">Duration in POI</td>
                    <td class="text-sm">:</td>
                    <td class="text-sm">
                      {{
                        finalData.duration_poi
                          ? getSimpleDurationV2(finalData.duration_poi)
                          : '0s'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-sm">Time in</td>
                    <td class="text-sm">:</td>
                    <td class="text-sm" v-if="!isGeo">
                      {{ finalData.time_in }}
                    </td>
                    <td class="text-sm" v-if="isGeo">
                      {{ isGeoEnd ? finalData.device_time :' -' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-sm">Time Out</td>
                    <td class="text-sm">:</td>
                    <td class="text-sm" v-if="!isGeo">
                      {{ finalData.time_out }}
                    </td>
                    <td class="text-sm" v-if="isGeo">
                      {{ !isGeoEnd ? finalData.device_time :' -' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </vs-card>
        <div v-if="!isGeoEnd" class="flex flex-row" style="gap: 10px">
          <table v-if="userRole.role_name != 'Customer'">
            <tr>
              <td class="text-sm">Distance</td>
              <td class="text-sm">:</td>
              <td class="text-sm">
                {{
                  finalData.distance_travel
                    ? finalData.distance_travel / 1000
                    : '0'
                }}
                km
              </td>
            </tr>
            <tr>
              <td class="text-sm">Travel Time</td>
              <td class="text-sm">:</td>
              <td class="text-sm">
                {{
                  finalData.travel_time
                    ? getSimpleDurationV2(finalData.travel_time)
                    : '0s'
                }}
              </td>
            </tr>
            <tr>
              <td class="text-sm">Average Speed</td>
              <td class="text-sm">:</td>
              <td class="text-sm">
                {{ finalData.average_speed ? finalData.average_speed : '0' }}
                km/h
              </td>
            </tr>
            <tr>
              <td class="text-sm">Max Speed</td>
              <td class="text-sm">:</td>
              <td class="text-sm">
                {{ finalData.max_speed ? finalData.max_speed : '0' }}
                km/h
              </td>
            </tr>
            <tr>
              <td class="text-sm">Total Alert</td>
              <td class="text-sm">:</td>
              <td class="text-sm">
                {{ finalData.alerts ? finalData.alerts.length : '0' }}&nbsp;
                |&nbsp;
                <span><a href="" @click="openAlerts"> See Details </a> </span>
                <!-- <span v-if="finalData.total_alert">See Details</span>
                <span v-else>No Alert</span> -->
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import geoDot from '../../assets/images/timeline/GeoDot.png'
import poiDot from '../../assets/images/timeline/PoiDot.png'
import auth from '../../repository/auth'

export default {
  name: 'RitationItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isGeo: false,
    isGeoEnd: false,
    isAlertsOpen: false,
    type: false,
  },
  computed: {
    alertOpenLocal: {
      get() {
        return this.isAlertsOpen
      },
      set(val) {
        this.isAlertsOpen = val
      },
    },
    finalData() {
      let finalItem = this.item
      // if (this.isGeo) {
      //   finalItem = {
      //     ...this.item,
      //     // : {
      //     //     ...this.item,
      //     //     dallas_temperature_1: finalItem.dallas_temperature_1,
      //     //     odometer: finalItem.odometer,
      //     //     distance: finalItem.distance_travel,
      //     //     travel_time: finalItem.travel_time,
      //     //     average_speed: finalItem.average_speed,
      //     //     max_speed: finalItem.max_speed,
      //     //   },
      //   }
      // }
      // const finalItem = {
      //   ...this.item,
      //  : {

      //   }
      // }

      return finalItem
    },
  },
  data() {
    return {
      icons: {
        geoDot: geoDot,
        poiDot: poiDot,
      },
      userRole: null,
    }
  },
  methods: {
    openAlerts(e) {
      e.preventDefault()
      this.isAlertsOpen = true
    },
    formatDate(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    },
  },
  mounted() {    
    console.log('mounted', this.type,this.item);
    
    this.userRole = JSON.parse(localStorage.getItem('userRole'));
  }
}
</script>

<style lang="scss">
.con-vs-popup .vs-popup {
  width: auto !important;
}
</style>
